export default __webpack_public_path__ + "static/media/upheavel.eae14dec.png";